import ColumnBase from "./ColumnBase.jsx";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { swivuGridSorterFn as sortable } from "../../other/utils/utils.jsx";

export default class SwivuSortColumn extends ColumnBase {
  static get $name() {
    return "SwivuSortColumn";
  }

  static get type() {
    return WIDGET_KEYS.swivuSortColumn;
  }

  static get defaults() {
    return {
      sortable
    }
  }
}
ColumnStore.registerColumnType(SwivuSortColumn);